module.exports = __webpack_public_path__ + "static/media/buy1.7faabc34.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/buy1.png
// module id = 970
// module chunks = 0